import { ActionReducer, createReducer, on } from '@ngrx/store';

import {
  addGeozonesGroup,
  deleteGeozonesGroup,
  loadGeozonesGroups,
  loadGeozonesGroupsFailure,
  loadGeozonesGroupsSuccess,
  updateGeozonesGroup,
} from '@store/geozoneGroups/geozoneGroups.actions';
import {
  geozoneGroupsAdapter,
  GeozoneGroupsState,
  initialGeozoneGroupsState,
} from '@store/geozoneGroups/geozoneGroups.state';

export const geozonesGroupsReducer: ActionReducer<GeozoneGroupsState> = createReducer(
  initialGeozoneGroupsState,
  on(loadGeozonesGroups, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),

  on(loadGeozonesGroupsSuccess, (state, { list }) =>
    geozoneGroupsAdapter.setAll(list, {
      ...state,
      loading: false,
    }),
  ),

  on(loadGeozonesGroupsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(addGeozonesGroup, (state, { item }) => geozoneGroupsAdapter.addOne(item, state)),
  on(updateGeozonesGroup, (state, { id, changes }) =>
    geozoneGroupsAdapter.updateOne({ id: +id, changes }, state),
  ),
  on(deleteGeozonesGroup, (state, { id }) => geozoneGroupsAdapter.removeOne(+id, state)),
);
